import * as React from "react";
import { Image } from "../Image/image";

const Diet = ({ diet }) => (
  <Image mediaName={`indicator_diet_${diet}`} mediaType="svg" alt={diet} />
);
export default Diet;
